/**
 * Authentication and authorization types.
 * JWT tokens, capabilities, and role definitions.
 */
/** System role definitions (immutable) */
export const SYSTEM_ROLES = {
    viewer: {
        name: "Viewer",
        description: "Read-only access to configurations and analytics",
        capabilities: ["config:read", "products:read", "analytics:read"],
        isSystem: true,
    },
    editor: {
        name: "Editor",
        description: "Can edit configurations and products",
        capabilities: [
            "config:read",
            "config:write",
            "products:read",
            "products:write",
            "products:upload",
            "analytics:read",
        ],
        isSystem: true,
    },
    publisher: {
        name: "Publisher",
        description: "Can promote configurations to live",
        capabilities: [
            "config:read",
            "config:write",
            "config:promote",
            "products:read",
            "products:write",
            "products:upload",
            "analytics:read",
        ],
        isSystem: true,
    },
    admin: {
        name: "Administrator",
        description: "Full access to tenant",
        capabilities: [
            "config:read",
            "config:write",
            "config:promote",
            "config:rollback",
            "products:read",
            "products:write",
            "products:delete",
            "products:upload",
            "analytics:read",
            "analytics:export",
            "admin:users",
            "admin:roles",
            "admin:tenants",
            "admin:audit",
            "admin:health",
        ],
        isSystem: true,
    },
};
